import { render, staticRenderFns } from "./DashboardAdminBengkulu.vue?vue&type=template&id=1d6343ca&lang=pug"
import script from "./DashboardAdminBengkulu.vue?vue&type=script&lang=js"
export * from "./DashboardAdminBengkulu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports